<div class="footer-container flex justify-center p-5">
  <span>{{ year }} © Bussify</span>
</div>
